import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { addAmenityFailure, addAmenitySuccess, AmenityFailure, AmenitySuccess, deleteAmenityFailure, deleteAmenitySuccess } from "../../Actions";
import { api } from "../../Config/ApiInterface";

// GET Room Types
function* getAmenitySaga(action) {
  try {
    let hotel_id=localStorage.getItem("hotel_id")
    const response = yield call(api.post, `/hotel/amenity/all?hotel_id=${hotel_id}`);
    if (response) {
      yield put(AmenitySuccess(response.data));
    } else {
      yield put(AmenityFailure(response.error ||"Failed to fetch Amenities."));
    }
  } catch (error) {
    yield put(AmenityFailure(error));
    toast.error("Failed to fetch Amenities.");
  }
}

//add room type
function* addAmenitySaga(action) {
  try {
    const response = yield call(api.post, `/hotel/amenity/create`,action.payload);
    if (response) {
      yield put(addAmenitySuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(addAmenityFailure(response.error || "Failed to add room types."));
    }
  } catch (error) {
    console.log("erroe",error)
    yield put(addAmenityFailure(error));
    toast.error("Failed to add room types.");
  }
}
// update
function* updateAmenitySaga(action) {
  try {
    const response = yield call(api.put, `/hotel/amenity/${action.payload?.id}`,action.payload);
    if (response) {
      yield put(addAmenitySuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(addAmenityFailure(response.error || "Failed to add room types."));
    }
  } catch (error) {
    console.log("erroe",error)
    yield put(addAmenityFailure(error));
    toast.error("Failed to add room types.");
  }
}

//delete room type
function* deleteAmenitySaga(action) {
  try {
    const response = yield call(api.delete, `/hotel/amenity/${action.payload?.id}`);
    if (response) {
      yield put(deleteAmenitySuccess(response.data));
    } else {
      yield put(deleteAmenityFailure(response.error || "Failed to delete room types."));
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteAmenityFailure(error));
    toast.error("Failed to delete room types.");
  }
}

export {deleteAmenitySaga,addAmenitySaga,updateAmenitySaga,getAmenitySaga}
